import { ClientConfig } from "../../app/models/responseModels/clientsResponse";
import { FilterableColumns } from "../../components/common/filter/GridDataFilter";

export enum CLIENTS_COLUMN_NAME {
  CLIENT_ID = "id",
  CLIENT_NAME = "clientName",
  CLIENT_LOGO = "clientLogo",
  DESCRIPTION = "description",
  BILLING_ADDRESS = "billingAddress",
  CITY = "city",
  STATE = "state",
  ZIP_CODE = "zipCode",
  CREATED_ON = "createdOn",
  UPDATED_ON = "updatedOn",

  TOTAL_STORES = "totalStores",
  TOTAL_ROUTES = "totalRoutes",
  PACKAGES_TENDERED = "packagesTendered",
  ORDERS_DELIVERED = "ordersDelivered",
  UNDELIVERED_NO_ATTEMPT = "undeliveredNoAttempt",
  UNDELIVERED_ATTEMPT = "undeliveredAttempt",
  GROSS_PERFORMANCE = "grossPerformance",
  NET_PERFORMANCE = "netPerformance",
}

export enum CLIENTS_LABEL_NAME {
  CLIENT_ID = "Client ID",
  CLIENT_TYPE = "Client Type",
  CLIENT_NAME = "Client Name",
  CLIENT_LOGO = "Client Logo",
  DESCRIPTION = "Description",
  BILLING_ADDRESS = "Billing Address",
  CITY = "City",
  STATE = "State",
  ZIP_CODE = "ZipCode",
  CREATED_ON = "Created On",
  UPDATED_ON = "Updated On",

  TOTAL_STORES = "Total Parcel Center(s)/Store(s)",
  TOTAL_ROUTES = "Total Route(s)",
  PACKAGES_TENDERED = "Packages Tendered",
  ORDERS_DELIVERED = "Order(s) Delivered",
  UNDELIVERED_NO_ATTEMPT = "Undelivered No Attempt",
  UNDELIVERED_ATTEMPT = "Undelivered Attempt",
  GROSS_PERFORMANCE = "Gross Performance",
  NET_PERFORMANCE = "Net Performance",
}

export const CLIENTS_FILTER_COLUMN_OPTIONS = [
  {
    label: CLIENTS_LABEL_NAME.CLIENT_NAME,
    value: CLIENTS_COLUMN_NAME.CLIENT_NAME,
  },
  {
    label: CLIENTS_LABEL_NAME.CLIENT_LOGO,
    value: CLIENTS_COLUMN_NAME.CLIENT_LOGO,
  },
  {
    label: CLIENTS_LABEL_NAME.DESCRIPTION,
    value: CLIENTS_COLUMN_NAME.DESCRIPTION,
  },
  {
    label: CLIENTS_LABEL_NAME.BILLING_ADDRESS,
    value: CLIENTS_COLUMN_NAME.BILLING_ADDRESS,
  },
  {
    label: CLIENTS_LABEL_NAME.CITY,
    value: CLIENTS_COLUMN_NAME.CITY,
  },
  {
    label: CLIENTS_LABEL_NAME.STATE,
    value: CLIENTS_COLUMN_NAME.STATE,
  },
  {
    label: CLIENTS_LABEL_NAME.ZIP_CODE,
    value: CLIENTS_COLUMN_NAME.ZIP_CODE,
  },
];

export const ddClientpageGridFilter: FilterableColumns = {
  id: {
    displayName: "Client ID",
    options: [],
    type: "number",
  },
  clientType: {
    displayName: "Client Type",
    options: [],
    type: "string",
  },
  clientName: {
    displayName: "Client Name",
    options: [],
    type: "string",
  },
  /* description: {
    displayName: "Description",
    options: [],
    type: "string",
  },
  billingAddress: {
    displayName: "Billing Address",
    options: [],
    type: "string",
  },
  city: {
    displayName: "City",
    options: [],
    type: "string",
  },
  state: {
    displayName: "State",
    options: [],
    type: "string",
  },
  zipCode: {
    displayName: "ZipCode",
    options: [],
    type: "string",
  }, */
  totalStores: {
    displayName: "Total Store(s)/Total Parcel Center(s)",
    options: [],
    type: "number",
  },
  packagesTendered: {
    displayName: "Packages Tendered",
    options: [],
    type: "number",
  },
  ordersDelivered: {
    displayName: "Orders Delivered",
    options: [],
    type: "number",
  },
  undeliveredNoAttempt: {
    displayName: "Undelivered No Attempt",
    options: [],
    type: "number",
  },
  undeliveredAttempt: {
    displayName: "Undelivered Attempt",
    options: [],
    type: "number",
  },
  createdOn: {
    displayName: "Created On",
    options: [],
    type: "datetime-range",
  },
  updatedOn: {
    displayName: "Updated On",
    options: [],
    type: "datetime-range",
  },
};

export type DeliveryType = "DEDICATED" | "E2E" | "BOTH";

export function getDeliveryDescription(
  clientConfig: ClientConfig[],
  deliveryMapping: Record<DeliveryType, string>
) {
  const keyName = "type_of_client";
  const dedicatedDelivery = clientConfig.find((e) => e.keyName === keyName);
  let deliveryDescription = "Co-mingled Delivery"; // Default value if not found

  if (
    dedicatedDelivery &&
    deliveryMapping.hasOwnProperty(dedicatedDelivery.value)
  ) {
    deliveryDescription = (deliveryMapping as any)[dedicatedDelivery.value];
  }

  return deliveryDescription;
}
